import {
	post,
	get
} from './config'
// import storage from '../common/storage'

// 登录
export const  Login = (params = {}) => post('/login', params)

// 发送短信
export const  sendCode = (params = {}) => post('/send-code', params)

// 发送短信
export const  userLoginLog = (params = {}) => post('/user-login-log', params)

// 绑定手机号
export const  bindingPhone = (params = {}) => post('/binding-phone', params)
// 账户密码登陆
export const  passLogin = (params = {}) => post('pass-login', params)
// 专业类别列表
export const  MajorList = (params = {}) => post('/major-list', params)

// 首页数据
export const  indexMemberStatistic = (params = {}) => post('/indexMemberStatistic', params)

// 专业保存
export const  userMajor = (params = {}) => post('/user-major', params)

// 轮播图
export const  getAdvertising = (params = {}) => post('/getAdvertising', params)

// 资讯列表
export const information  = (params = {}) => post('/information', params)

// 积分规则
export const userIntegral  = (params = {}) => post('/user-integral', params)

// 积分规则
export const integralRule  = (params = {}) => post('/integral-rule', params)

// 单词本-首页
export const getEnglishBookPlan  = (params = {}) => post('/getEnglishBookPlan', params)

// 单词本-添加计划页面
export const getEnglishBookList  = (params = {}) => post('/getEnglishBookList', params)

// 单词本-调整计划页面-添加计划
export const addEnglishBookPlan  = (params = {}) => post('/addEnglishBookPlan', params)

// 单词本-背单词日历
export const getEnglishStudyCalendar  = (params = {}) => post('/getEnglishStudyCalendar', params)

// 单词本-切换计划
export const changeEnglishBookPlan  = (params = {}) => post('/changeEnglishBookPlan', params)

// 单词本-我的计划书籍
export const getEnglishBookPlanList  = (params = {}) => post('/getEnglishBookPlanList', params)

// 单词本-删除计划
export const delEnglishBookPlan  = (params = {}) => post('/delEnglishBookPlan', params)

// 单词本-记住单词
export const studyEnglishWord  = (params = {}) => post('/studyEnglishWord', params)

// 单词本-调整计划
export const setEnglishBookPlan  = (params = {}) => post('/setEnglishBookPlan', params)

// 用户分享的积分
export const userShare  = (params = {}) => post('/user-share', params)

// 重置学习进度
export const resetEnglishStudyPlan  = (params = {}) => post('/resetEnglishStudyPlan', params)

// 随机刷题
export const randomLearnSubject  = (params = {}) => post('/randomLearnSubject', params)

// 随机刷题-获取答案
export const randomGetAnswer  = (params = {}) => post('/randomGetAnswer', params)

// 获取问题
export const randomGetQuestion  = (params = {}) => post('/randomGetQuestion', params)

// 提交问题答案
export const randomSubmitAnswer  = (params = {}) => post('/randomSubmitAnswer', params)

// 随机刷题-答题卡
export const randomAnswerSheet  = (params = {}) => post('/randomAnswerSheet', params)

// 随机刷题-清空答题记录
export const randomClearHistory  = (params = {}) => post('/randomClearHistory', params)

// 收藏错题
export const collectWrong  = (params = {}) => post('/collectWrong', params)

// 错题集-收藏、取消错题
export const collectWrongWord  = (params = {}) => post('/collectWrongWord', params)

// 收藏错题-2.0
export const collectWrongSecondEdition  = (params = {}) => post('/collectWrongSecondEdition', params)

// 积分商城-商品分类
export const goodsType  = (params) => post('/goods/type', params)

// 积分商城列表
export const goodsLists  = (params) => post('/goods/lists', params)

// 积分商城商品分类
export const goodsDetail  = (params) => post('/goods/detail', params)

// 兑换商品
export const goodsExchange  = (params) => post('/goods/exchange', params)

// 兑换记录
export const goodsExchangeRecord  = (params) => post('/goods/exchangeRecord', params)

// 兑换详情
export const goodsExchangeInfo  = (params) => post('/goods/exchangeInfo', params)

// 消息列表
export const messageList  = (params = {}) => post('/message-list', params)

// 消息详情
export const messageDetails  = (params = {}) => post('/message-details', params)

// 咨询分类
export const informationType  = (params = {}) => post('/information-type', params)

// 咨询列表
export const informationList  = (params = {}) => post('/information', params)

// 个人信息
export const userInfo  = (params = {}) => post('/user-info', params)

// 用户编辑更新信息
export const userInfoUpdated  = (params = {}) => post('/user-info-updated', params)

// 上传图片
export const uploadFile  = (params = {}) => post('/upload-file', params)

// 每日一练
export const dailyStudyIndex  = (params = {}) => post('/dailyStudyIndex', params)

// 每日一练-分享解锁加强练习
export const unlockReinforce  = (params = {}) => post('/unlockReinforce', params)

// 每日一练-我的练习
export const getHistoryDailyStudy  = (params = {}) => post('/getHistoryDailyStudy', params)

// 每日一练-开始练习
export const startDailyStudy  = (params = {}) => post('/startDailyStudy', params)

// 每日一练-提交答案
export const submitQuestion  = (params = {}) => post('/submitQuestion', params)

// 每日一练-答题报告
export const getHistoryDailyStudyReport  = (params = {}) => post('/getHistoryDailyStudyReport', params)

// 每日一练-答题解析
export const getDailyStudyAnalysis  = (params = {}) => post('/getDailyStudyAnalysis', params)

// 会员商品列表
export const userGrade  = (params = {}) => post('/user-grade', params)

// 会员商品列表
export const buyGrade  = (params = {}) => post('/buy-grade', params)

// 我的错题
export const myMistake  = (params = {}) => post('/my-mistake', params)

// 我的错题-题目
export const myMistakeQuestion  = (params = {}) => post('/my-mistake-question', params)

// 我的错题-答题卡
export const myMistakeAnswerSheet  = (params = {}) => post('/my-mistake-answer-sheet', params)

// 答题闯关-专业科目列表
export const gateLevelSubject  = (params = {}) => post('/gateLevelSubject', params)

// 答题闯关-关卡列表
export const getGateLevel  = (params = {}) => post('/getGateLevel', params)

// 答题闯关-问题
export const getGateLevelQuestion  = (params = {}) => post('/getGateLevelQuestion', params)

// 答题闯关-分享的积分
export const shareUnlockGateLevel  = (params = {}) => post('/shareUnlockGateLevel', params)

// 答题闯关-答题报告
export const gateLevelHistoryReport  = (params = {}) => post('/gateLevelHistoryReport', params)

// 答题闯关-提交问题答案
export const submitGateLevelQuestion  = (params = {}) => post('/submitGateLevelQuestion', params)

// 答题闯关-查看解析
export const gateLevelComeOut  = (params = {}) => post('/gateLevelComeOut', params)

// 历年真题
export const testPaper  = (params = {}) => post('/test-paper', params)

// 历年真题-我的练习
export const examLog  = (params = {}) => post('/exam-log', params)

// 历年真题-试卷题
export const testPaperQuestion  = (params = {}) => post('/test-paper-question', params)

// 历年真题-提交答案
export const testPaperSubmit  = (params = {}) => post('/test-paper-submit', params)

// 历年真题-答题报告
export const answerReport  = (params = {}) => post('/answer-report', params)

// 历年真题-查看解析
export const showAnalysis  = (params = {}) => post('/show-analysis', params)

// 历年真题-查看解析答题卡
export const answerCard  = (params = {}) => post('/answer-card', params)

// 专业列表
export const practiceExamSubject  = (params = {}) => post('/practiceExamSubject', params)

// 模拟考试列表
export const practiceExamPaper  = (params = {}) => post('/practiceExamPaper', params)

// 模拟考试-试卷
export const getPracticeExamQuestion  = (params = {}) => post('/getPracticeExamQuestion', params)

// 模拟考试-提交答案
export const submitPracticeExamAnswer  = (params = {}) => post('/submitPracticeExamAnswer', params)

// 模拟考试-答题报告
export const practiceExamHistoryReport  = (params = {}) => post('/practiceExamHistoryReport', params)


// 模拟考试-答题解析
export const practiceExamComeOut  = (params = {}) => post('/practiceExamComeOut', params)

// 模拟考试-我的练习
export const practiceExamUserAnswerList  = (params = {}) => post('/practiceExamUserAnswerList', params)

// 考点刷题-考点列表
export const sitePlaceLists  = (params = {}) => post('/site/place-lists', params)
// 考点刷题-试卷列表
export const siteLists  = (params = {}) => post('/site/lists', params)
// 考点刷题-试卷列表 按考点取试卷
export const siteListsV2  = (params = {}) => post('/site/listsv2', params)

// 考点刷题-题目
export const siteTopic  = (params = {}) => post('/site/topic', params)

// 考点刷题-提交答案
export const siteRandomSubmitAnswer  = (params = {}) => post('/site/randomSubmitAnswer', params)

// 考点刷题-答题卡
export const siteRandomAnswerSheet  = (params = {}) => post('/site/randomAnswerSheet', params)

// 考点刷题-清空重做
export const siteRandomClearHistory  = (params = {}) => post('/site/randomClearHistory', params)

// 错题反馈
export const errorFeedback  = (params = {}) => post('/errorFeedback', params)

// 模考大赛
export const dryRunMatch  = (params = {}) => post('/dry-run-match', params)

// 模考大赛-报名参赛
export const matchSignUp  = (params = {}) => post('/match-sign-up', params)

// 模考大赛-题目
export const dryRunMatchQuestion  = (params = {}) => post('/dry-run-match-question', params)

// 模考大赛-提交考试
export const dryRunMatchSubmit  = (params = {}) => post('/dry-run-match-submit', params)

// 模考大赛-答题报告
export const matchAnswerReport  = (params = {}) => post('/match-answer-report', params)

// 模考大赛-查看解析
export const matchShowAnalysis  = (params = {}) => post('/match-show-analysis', params)

// 模考大赛-解析答题卡
export const matchAnswerCard  = (params = {}) => post('/match-answer-card', params)

// 模考大赛-排行榜
export const matchRanking  = (params = {}) => post('/match-ranking', params)

// 模考大赛-我的模考大赛
export const matchExamLog  = (params = {}) => post('/match-exam-log', params)

// 分享配置
export const getSignPackage  = (params = {}) => post('/getSignPackage', params)

// 兑换码兑换
export const exchangecode  = (params = {}) => post('/user-exchangecode', params)

// 购买真题试卷
export const buyTest  = (params = {}) => post('/buy-text', params)

// 套餐列表
export const meal  = (params = {}) => post('/meal', params)
// 购买真题试卷
export const buyMeal  = (params = {}) => post('/buy-meal', params)